import React, { useEffect, useState } from "react";
import { fetchServiceAndTaxSettings, saveServiceAndTaxSettingsAndSessions } from "../../../../services/Settings/ServicesandTaxSettingsAndSessios/ServicesAndTaxApi";
import { Box, Typography, CircularProgress, Grid, Paper, Tabs, Tab, TextField, Button, Switch, FormControlLabel } from "@mui/material";
import Deliveryservice from "./Deliveryservice"; // ✅ استيراد المكون
import { useFeatures } from "../../../../context/PermissionsAndFeatures/FeaturesContext";

const ServicesandTaxTap = () => {
  const [service, setService] = useState("");
  const [tax, setTax] = useState("");
  const [delivery, setDelivery] = useState("");
  const [session, setSession] = useState("");
  const [shift, setShift] = useState("");
  const [taxIsPercentage, setTaxIsPercentage] = useState(true);
  const [serviceIsPercentage, setServiceIsPercentage] = useState(true);
  const [deliveryIsPercentage, setDeliveryIsPercentage] = useState(false);
  const [isServiceRequired, setIsServiceRequired] = useState(true);
  const [isDeliveryRequired, setIsDeliveryRequired] = useState(false);
  const [isTaxRequired, setIsTaxRequired] = useState(true);
  const [saving, setSaving] = useState(false);
  const [successMsg, setSuccessMsg] = useState("");
  const [settings, setSettings] = useState(null);
  const [loading, setLoading] = useState(true);
  const [tabIndex, setTabIndex] = useState(0); // ✅ حالة التاب الداخلي
  const [ctrlPPrint, setCtrlPPrint] = useState(false);
  const [autoPreparationPrint, setAutoPreparationPrint] = useState(false);
  const [invoiceIncrement, setinvoice_incremant] = useState(""); // اجعلها فارغة افتراضياً

  // استخلاص حالة الميزات
  const { hasFeature, featuresLoading } = useFeatures();
  const taxServiceDeliveryEnabled = !featuresLoading && hasFeature("tax_service_delivery");

  // جلب الإعدادات دائماً عند التركيب (حتى لو الميزة معطّلة) لعرضها للقراءة فقط
  useEffect(() => {
    fetchServiceAndTaxSettings()
      .then((data) => {
        setSettings(data);
        setService(data.service || "");
        setTax(data.tax || "");
        setDelivery(data.delivery || "");
        setTaxIsPercentage(Boolean(data.tax_is_percentage));
        setServiceIsPercentage(Boolean(data.service_is_percentage));
        setDeliveryIsPercentage(Boolean(data.delivery_is_percentage));
        setIsServiceRequired(Boolean(data.is_service_required));
        setIsDeliveryRequired(Boolean(data.is_delivery_required));
        setIsTaxRequired(Boolean(data.is_tax_required));
        setSession(data.session || "");
        setShift(data.shift || "");
        setCtrlPPrint(Boolean(data.ctrl_p_print)); // جلب ctrl_p_print
        setAutoPreparationPrint(Boolean(data.auto_preparation_print)); // جلب auto_preparation_print
        setinvoice_incremant(data.invoice_incremant || ""); // اجلبها كما هي من البيانات
      })
      .catch(() => setSettings(null))
      .finally(() => setLoading(false));
  }, []);

  const handleTabChange = (event, newValue) => {
    setTabIndex(newValue);
  };

  const handleSave = async () => {
    // منع الحفظ إذا الميزة معطّلة (ثانوي - زر نفسه سيُعطّل)
    if (!taxServiceDeliveryEnabled) {
      alert("🚫 لا يمكنك حفظ الإعدادات لأن ميزة الخدمات والضرائب والتوصيل معطّلة.");
      return;
    }

    setSaving(true);
    setSuccessMsg("");
    try {
      await saveServiceAndTaxSettingsAndSessions({
        service: service,
        tax: tax,
        delivery: delivery,
        tax_is_percentage: taxIsPercentage,
        service_is_percentage: serviceIsPercentage,
        delivery_is_percentage: deliveryIsPercentage,
        is_service_required: isServiceRequired,
        is_delivery_required: isDeliveryRequired,
        is_tax_required: isTaxRequired,
        session: session,
        shift: shift,
        ctrl_p_print: ctrlPPrint ? 1 : 0,
        auto_preparation_print: autoPreparationPrint ? 1 : 0,
        invoice_incremant: invoiceIncrement,
      });
      setSuccessMsg("✅ تم حفظ الإعدادات بنجاح!");
    } catch (err) {
      setSuccessMsg("❌ فشل في حفظ الإعدادات.");
    } finally {
      setSaving(false);
      setTimeout(() => setSuccessMsg(""), 3000);
    }
  };

  // أثناء تحميل حالة الميزات
  if (featuresLoading) {
    return (
      <Box sx={{ display: "flex", justifyContent: "center", my: 4 }}>
        <CircularProgress />
      </Box>
    );
  }

  // بعد تحميل الميزات: اعرض الصفحة دائماً، لكن عطل الحقول والعمليات إن كانت الميزة معطّلة
  if (loading) {
    return (
      <Box sx={{ display: "flex", justifyContent: "center", my: 4 }}>
        <CircularProgress />
      </Box>
    );
  }

  // التحكم في تعطيل الحقول والأزرار
  const controlsDisabled = !taxServiceDeliveryEnabled;

  return (
    <Paper sx={{ p: 3, mt: 2 }}>
      {/* تحذير ظاهر عندما تكون الميزة معطّلة */}
      {!taxServiceDeliveryEnabled && (
        <Box sx={{ mb: 2 }}>
          <Typography variant="body1" color="error" align="center">
            🚫 ميزة الخدمات والضرائب والتوصيل (tax_service_delivery) غير مفعّلة. الصفحة للعرض فقط — لا يمكن إجراء تغييرات أو إنشاء عمليات.
          </Typography>
        </Box>
      )}

      <Tabs
        value={tabIndex}
        onChange={handleTabChange}
        indicatorColor="primary"
        textColor="primary"
        sx={{ mb: 2 }}
      >
        <Tab label="إعدادات الخدمات والضرائب" />
        <Tab label="تعريف شرائح التوصيل" />
      </Tabs>

      {tabIndex === 0 && (
        !settings ? (
          <Typography color="error" align="center" sx={{ mt: 3 }}>
            تعذر جلب إعدادات الخدمات والضرائب.
          </Typography>
        ) : (
          <Box>
            <Typography variant="h6" gutterBottom>
              إعدادات الخدمات والضرائب
            </Typography>
            <Grid container spacing={2}>
              <Grid item xs={12} sm={6}>
                <TextField
                  label="الضريبة"
                  type="number"
                  value={tax}
                  onChange={e => setTax(e.target.value)}
                  fullWidth
                  sx={{ mt: 1 }}
                  disabled={controlsDisabled}
                />
                <FormControlLabel
                  control={
                    <Switch
                      checked={taxIsPercentage}
                      onChange={e => setTaxIsPercentage(e.target.checked)}
                      color="primary"
                      disabled={controlsDisabled}
                    />
                  }
                  label={taxIsPercentage ? "نسبة %" : "مبلغ ثابت"}
                  sx={{ mt: 1 }}
                />
                <FormControlLabel
                  control={
                    <Switch
                      checked={isTaxRequired}
                      onChange={e => setIsTaxRequired(e.target.checked)}
                      color="primary"
                      disabled={controlsDisabled}
                    />
                  }
                  label={isTaxRequired ? "الضريبة مطلوبة" : "الضريبة غير مطلوبة"}
                  sx={{ mt: 1 }}
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  label="الخدمة"
                  type="number"
                  value={service}
                  onChange={e => setService(e.target.value)}
                  fullWidth
                  sx={{ mt: 1 }}
                  disabled={controlsDisabled}
                />
                <FormControlLabel
                  control={
                    <Switch
                      checked={serviceIsPercentage}
                      onChange={e => setServiceIsPercentage(e.target.checked)}
                      color="primary"
                      disabled={controlsDisabled}
                    />
                  }
                  label={serviceIsPercentage ? "نسبة %" : "مبلغ ثابت"}
                  sx={{ mt: 1 }}
                />
                <FormControlLabel
                  control={
                    <Switch
                      checked={isServiceRequired}
                      onChange={e => setIsServiceRequired(e.target.checked)}
                      color="primary"
                      disabled={controlsDisabled}
                    />
                  }
                  label={isServiceRequired ? "الخدمة مطلوبة" : "الخدمة غير مطلوبة"}
                  sx={{ mt: 1 }}
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  label="التوصيل"
                  type="number"
                  value={delivery}
                  onChange={e => setDelivery(e.target.value)}
                  fullWidth
                  sx={{ mt: 1 }}
                  disabled={controlsDisabled}
                />
                <FormControlLabel
                  control={
                    <Switch
                      checked={deliveryIsPercentage}
                      onChange={e => setDeliveryIsPercentage(e.target.checked)}
                      color="primary"
                      disabled={controlsDisabled}
                    />
                  }
                  label={deliveryIsPercentage ? "نسبة %" : "مبلغ ثابت"}
                  sx={{ mt: 1 }}
                />
                <FormControlLabel
                  control={
                    <Switch
                      checked={isDeliveryRequired}
                      onChange={e => setIsDeliveryRequired(e.target.checked)}
                      color="primary"
                      disabled={controlsDisabled}
                    />
                  }
                  label={isDeliveryRequired ? "التوصيل مطلوب" : "التوصيل غير مطلوب"}
                  sx={{ mt: 1 }}
                />
              </Grid>
              {/* أخفي خانة الجلسة والشيفت ولا ترسمها */}
              {/* <Grid item xs={12} sm={6}>
                <TextField
                  label="الجلسة"
                  value={session}
                  onChange={e => setSession(e.target.value)}
                  fullWidth
                  sx={{ mt: 1 }}
                />
                <TextField
                  label="الشيفت"
                  value={shift}
                  onChange={e => setShift(e.target.value)}
                  fullWidth
                  sx={{ mt: 1 }}
                />
              </Grid> */}
              <Grid item xs={12}>
                <Button
                  variant="contained"
                  color="primary"
                  sx={{ mt: 2 }}
                  onClick={handleSave}
                  disabled={saving || controlsDisabled}
                >
                  {saving ? "جاري الحفظ..." : "حفظ الإعدادات"}
                </Button>
                {successMsg && (
                  <Typography sx={{ mt: 2, color: successMsg.startsWith("✅") ? "green" : "red" }}>
                    {successMsg}
                  </Typography>
                )}
              </Grid>
            </Grid>
          </Box>
        )
      )}

      {tabIndex === 1 && (
        // مرّر العلامة ليعرف مكون شرائح التوصيل إن كانت العمليات مسموح بها
        <Deliveryservice operationsAllowed={taxServiceDeliveryEnabled} />
      )}
    </Paper>
  );
};

export default ServicesandTaxTap;